import { TCustomer, TNotify, TUser } from "./types/AllTypes";

export const emptyNotify: TNotify = {
  title: "",
  body: ""
};

export function toIsoString(date: Date) {
  const tzo = -date.getTimezoneOffset(),
    dif = tzo >= 0 ? "+" : "-",
    pad = function (num: number) {
      return (num < 10 ? "0" : "") + num;
    };

  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds()) +
    dif +
    pad(Math.floor(Math.abs(tzo) / 60)) +
    ":" +
    pad(Math.abs(tzo) % 60)
  );
}

export const customerToString = (customer: TCustomer) => {
  return `${customer.meno} ${customer.cislo} ${customer.id}`;
};

export const userToString = (user: TUser) => {
  return `${user.first_name} ${user.last_name}`;
};
